import * as React from 'react';
import { Input, Label } from 'semantic-ui-react';

import * as rutUtils from 'src/modulos/Matriculas/IngresoNuevaMatricula/utils/rut';

export interface RutProps {
    requerido?: boolean;
    error?: boolean;
    rut: string;
    alCambiarRut(rut: string): void;
}

export const Rut: React.FunctionComponent<RutProps> = props => {
    const { requerido = false, error = false, rut, alCambiarRut } = props;

    return (
        <Input
            placeholder='12.345.678-9'
            type='text'
            value={rut}
            onChange={(_e, { value }) => {
                alCambiarRut(rutUtils.formatear(value));
            }}
            required={requerido}
        >
            <input />
            {error && (
                <Label color='red' pointing='left'>
                    El rut no es válido.
                </Label>
            )}
        </Input>
    );
};

export default Rut;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/RutPasaporte/componentes/Rut/index.tsx